import React from "react";

function Meetscotty() {
  return (
    <>
      <section className="buy_sell_section ">
        <div className="container pt-5 pb-3">
          <div className="row ">
            <div className="col-md-10 m-auto">
              <div className="guardian_box text-center">
                <h2 className="hadding hadding_bg  mb-0" data-aos="fade-up">
                  {" "}
                  <span className="sub-hadding">
                    Meet 
                    Scotty  V2
                  </span>{" "}
                  The OG Guardian of the Crypto Universe
                </h2>
                <p className="fw300">
                  In the wild west of crypto, one name stands above the
                  rest—Scotty the AI. More than just a memecoin, Scotty is an
                  AI-powered guardian, trader, and degen companion, designed to
                  navigate the chaos of the blockchain with intelligence, speed,
                  and meme-fueled precision. After a legendary first run, Scotty
                  V2 is back and stronger than ever—now on Solana. With
                  ultra-fast transactions, lower fees, and next-level
                  scalability, this is the evolution of AI memecoins. Scotty
                  doesn’t just keep up—he stays ahead. Whether it's tracking
                  trends, dropping alpha, or helping you snipe the next 100x,
                  Scotty has your back. Welcome to Scotty V2. The future of AI
                  memecoins is here.
                </p>
              </div>

              <div className="row">
                <div className="col-md-7 mt-3">
                  <div className="what_box1 scotty_box">
                    <div className="what_box">
                      <h2 className="hadding " data-aos="fade-up">
                        What Is <span className="color1">$Scotty?</span>
                      </h2>
                      <p className="fw300">
                        $SCOTTY is more than just a token—it’s a movement.
                        Powered by the Solana blockchain, Scotty V2 brings meme
                        magic and AI precision into one unstoppable force.
                      </p>

                      <ul className="fw300">
                        <li data-aos="fade-up">
                          <i className="bi bi-record2"></i>AI-Driven Insights –
                          Instant token analysis, real-time liquidity tracking,
                          and community-powered intelligence.
                        </li >
                        <li data-aos="fade-up">
                          <i className="bi bi-record2"></i>Solana-Powered Speed
                          – Faster swaps, lower fees, and seamless transactions.
                        </li>
                        <li data-aos="fade-up">
                          <i className="bi bi-record2"></i>Next-Level Staking –
                          Earn rewards while holding the ultimate AI memecoin.
                        </li>
                        <li data-aos="fade-up">
                          <i className="bi bi-record2"></i>Exclusive Airdrops &
                          Rewards – Loyalty pays—big time.
                        </li>
                      </ul>

                      <p className="ai-revo">
                        This isn't just another dog token <br />{" "}
                        <b> — this is the AI revolution.</b>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-5 mt-3">
                  <div className="what_box2 what_box-height" >
                    <img
                      src="/assets/img/icon3.png"
                      alt="logo"
                      className="img-fluid"
                      data-aos="fade-left"
                    />
                  </div>
                </div>
                <div className="col-md-12 mt-3">
                  <div className="guardian_box text-center add-solan">
                    <h2 className="hadding hadding_bg  mb-0">
                      {" "}
                      <span className="sub-hadding">
                      This is scotty, THE original AI Agent!{" "}
                      </span>{" "}
                      <b>
                        <img
                          src="/assets/img/solana.png"
                          className="solona"
                          alt="solana"
                        />{" "}
                        Powered by Solana Blockchain
                      </b>{" "}
                    </h2>
                  </div>
                </div>
                <div className="col-md-7 mt-3">
                  <div className=" ">
                    <img
                      src="/assets/img/icon4.jpg"
                      alt="logo"
                      className="img-fluid"
                       data-aos="fade-right"
                    />
                  </div>
                </div>

                <div className="col-md-5 mt-3">
                  <div className="p-2 scotty_box">
                    <small className="color1 fw300 "  data-aos="fade-up">
                      JOIN SCOTTY’S QUEST FOR KNOWLEDGE
                    </small>
                    <h2 className="hadding " data-aos="fade-up">Scotty's Adventures</h2>
                    <ul className="fw300">
                      <li data-aos="fade-up">
                        <i className="bi bi-record2"></i>Scotty stays current on
                        AI, blockchain, and cryptocurrency advancements with his
                        advanced AI system that gives him unparalleled insight
                        into the inner workings of blockchain technology. He
                        analyzes complex algorithms and code with ease, spotting
                        patterns and anomalies that even the most skilled human
                        programmers would miss.
                      </li>
                      <li data-aos="fade-up">
                        <i className="bi bi-record2"></i>With his incredible
                        memory he's able to recall every transaction, every
                        block,and every hash that has ever been recorded on the
                        blockchain. He sifts through vast amounts of data in
                        seconds, searching for clues and connections that others
                        can only dream of.
                      </li>
                      <li data-aos="fade-up">
                        <i className="bi bi-record2"></i>Moving through the
                        digital world with lightning-fast agility, darting
                        through the blockchain like a ghost in the machine.
                        Scotty bypasses security systems with ease, slipping
                        through the tiniest gaps in firewalls and encryption
                        algorithms.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Meetscotty;
